import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormField, Text, TextArea } from 'grommet'

import { useProvider } from 'hooks/useMoodPlot'
import FormSection from 'components/form/FormSection'

type Props = { fetching?: boolean }
export default function JournalField({ fetching = false }: Props) {
  const { t } = useTranslation()
  const { setJournal } = useProvider()
  return (
    <FormSection gap="small" margin={{ top: 'small' }}>
      <Text size="xsmall">{t('components.journal-field.description')}</Text>
      <FormField name="journal" htmlFor="journal">
        <TextArea
          rows={3}
          id="journal"
          size="small"
          name="journal"
          maxLength={500}
          resize="vertical"
          disabled={fetching}
          onChange={(e) => setJournal(e.currentTarget.value)}
        />
      </FormField>
    </FormSection>
  )
}
